import React, {useEffect, useState, useRef} from 'react';
import { useDispatch } from 'react-redux';
import {alertService} from '@app/services/alertService';

import {myService} from '@app/services/sukienService';
import Select from 'react-select';
import * as mainService from '@app/services/mainService';
import {useLocation} from 'react-router-dom';
import {getControllerName, getDefaultSelectValue} from '@app/utils/helpers';
import HeaderClick from '@app/utils/HeaderClick';
import {checkRole, createObj, updateObj} from '@app/services/mainService';
import {Button, Modal} from "react-bootstrap";
import {useSelector} from "react-redux";
import {Tabs, HRTag} from "@components";
import {
    image_root  , INIT_ROLE_MENU
} from "@app/const/AppSetting";

import {useTranslation} from "react-i18next";
import MyReactDatePicker from "@app/utils/MyReactDatePicker";
import {findObjInArr} from "@app/utils/CommonFunctions";
import GioitinhListComponent from '@app/pages/FUtil/GioitinhListComponent';
import AnchayListComponent from '@app/pages/FUtil/AnchayListComponent';
import NhadanListComponent from '@app/pages/FUtil/NhadanListComponent';
import NewDatePicker from '@app/pages/FUtil/NewDatePicker';
import DaohuuAutocompleteComponent from '@app/pages/FUtil/DaohuuAutocompleteComponent';
import DaohuuthamgiaEdit from '@app/pages/FSukien/FSukien/DaohuuthamgiaEdit';
import TailieuEdit from '@app/pages/FSukien/FSukien/TailieuEdit';
import DaohuuchitietEdit from '@app/pages/FSukien/FSukien/DaohuuchitietEdit';
import NhadanchitietEdit from '@app/pages/FSukien/FSukien/NhadanchitietEdit';
import './buttonmoveto.css';

import CountriesListComponent from '@app/pages/FUtil/CountriesListComponent';
import CityListComponent from '@app/pages/FUtil/CityListComponent';
import DistrictListComponent from '@app/pages/FUtil/DistrictListComponent';
import WardsListComponent from '@app/pages/FUtil/WardsListComponent';
import {ClipLoader} from "react-spinners";

import CoquanListComponent from '@app/pages/FUtil/CoquanListComponent';
import NhomsukienListComponent from '@app/pages/FUtil/NhomsukienListComponent';
import PhanloaisukienListComponent from '@app/pages/FUtil/PhanloaisukienListComponent';
import ThoiListComponent from "@pages/FUtil/ThoiListComponent";
import TrangthaiListComponent from "@pages/FUtil/TrangthaiListComponent";

function SukienEdit({history, match}) {
     const [t] = useTranslation();
    const location = useLocation();
    const dispatch = useDispatch();

    const currController = getControllerName(location.pathname);
    const [loading, setLoading] = useState(false);

    let {id} = match.params;
    let isAddMode = !id;
    const isDisplay = id && location.pathname.indexOf(`view`) > 0;
    const [handleToogle, setHandleToogle] = useState(false);

    const [hasRole, setHasRole] = useState(false);
    const [roleMenu, setRoleMenu] = useState(INIT_ROLE_MENU);
   // const [listNhadan, setListNhadan] = useState([]);

   const taiLieuRef = useRef(null);

   const daohuuthamgiaRef = useRef(null);

   const sukiendaohuuRef = useRef(null);
    const sukiennhadanRef = useRef(null);

   const scrollToTaiLieu = () => {
     taiLieuRef.current.scrollIntoView({ behavior: 'smooth' });
   };
   const scrollToDaohuuthamgia= () => {
    daohuuthamgiaRef.current.scrollIntoView({ behavior: 'smooth' });
  };
    const scrollToSukienDaohuu = () => {
        sukiendaohuuRef.current.scrollIntoView({ behavior: 'smooth' });
    };

    const scrollToSukienNhadan = () => {
        sukiennhadanRef.current.scrollIntoView({ behavior: 'smooth' });
    };

    const initial = {
        ngay:'',
        coquan_fk: null,
        nhomsukien_fk: null,
        phanloaisukien_fk: null,
        chu_de:'',
        thoi_fk: null,
        nhadan_fk :null,
        ghi_chu: '',
        link_image:'',
        id: id || 0,


    };

    const [obj, setObj] = useState({...initial});

    const onChangeInput = (e) => {
        console.log(e.target);
        const { name, value } = e.target;

        setObj((prevState) => {
            let newState = { ...prevState, [name]: value };
            if(name === 'coquan_fk')
            {
                newState.nhomsukien_fk = "";
                newState.phanloaisukien_fk = "";
            }
            if (name === "nhomsukien_fk") {
                newState.phanloaisukien_fk = "";
            }


            return newState;
        });

        setHandleToogle((prevSelected) => !prevSelected);
    };

    const createRs = async () => {

        if (!hasRole) {
            const role = await mainService.getRoleMENU(location.pathname);
            setRoleMenu(role);
            setHasRole(true);
        }

        if (!isAddMode) {
            myService.getById(id).then((response) => {
                console.log('getById', JSON.stringify(response, null, 2));

                if(!response || !response.data || !response.data.data)
                {
                    history.push('/'+currController);
                    alertService.error('Thông tin theo Id không tồn tại hoặc không thuộc quyền của bạn');
                }

                let userX = response.data.data;
                console.log(userX);
                setObj(userX);

            });
        }
        else
        {
            const cqtemp = await mainService.getAllNhadan({ path_access:currController});
            setObj((prevState) => ({
                ...prevState,
                nhadan_fks: cqtemp.map(obj=> ({ ...obj, checked: false }))
            }));
        }

    };

    useEffect(async () => {

         await checkRole({
                    pathname: location.pathname,
                    isAddMode,
                    currController,
                    history
                });

        await createRs();

    }, []);

    const saveClick = async () => {
        let data = obj;
        if(!data)
        {
            alert('Không xác định được trang vui lòng tải lại');
            return;
        }

        if(!data.chu_de || data.chu_de === 0)
        {
            alert('Vui lòng nhập chủ đề');
            return;
        }

         isAddMode ?  createSukien(data) : update(data);

    };


    const backBrowse = () => {
        history.push('/'+currController);
    };



    async function createSukien(data) {
        setLoading(true);
        // delete data.ma;
        const result = await myService.Create(data);
        if (result.status ==="1") {
            alertService.success(result.msg);

            history.push('/'+currController+'/edit/'+ result.data );

        } else {
            alertService.error(result.msg);
        }
        setLoading(false);
    }
    async function update(data) {
        setLoading(true);

        const result = await myService.Update(id,data);



        if (result.status ==="1") {
            alertService.success(result.msg);




        } else {
            alertService.error(result.msg);
        }
        setLoading(false);
    }


    if (loading) {
        return (
            <div className="flex justify-center items-center h-40">
                <ClipLoader color="#3498db" size={50} />
            </div>
        );
    }



    let htmlButtonSave = '';

    if(isDisplay <= 0 || isAddMode > 0){
        htmlButtonSave = (
            <Button
            className="btn  btn-success  mr-1"

            icon="right fas fa-angle-left"
        onClick={saveClick}
         >
        <i className="fa fa-save"> {isAddMode>0 ? "Tạo mới" :"Cập nhật"  } </i>
         </Button>
        );

    }

    /*const chonPK = (position,e) => {
        const {name, value, checked} = e.target;
        let q;
        let mAll;
        if(position === -1)
        {

            q = obj.nhadan_fks.map(obj=> ({ ...obj, checked: checked })) ;
            mAll = checked;
        }
        else
        {
            q = obj.nhadan_fks;
            q[position]['checked']= checked;
            mAll = obj.all;
        }
        setObj((prevState) => ({
            ...prevState,
            nhadan_fks: q,
            all:mAll
        }));
        setHandleToogle((prevSelected) => {
            return !prevSelected;
        });

    };*/

    // eslint-disable-next-line no-shadow
    return (

        <div className="card card-primary">
            <HeaderClick
                headerName={roleMenu.tenmenu}
                isAddMode={isAddMode}
                isDisplay={isDisplay}
                history={history}
                currController={currController}
            />
            <div className="card-body">
                { !isAddMode && ( <button  className="daohuuthamgia-button" onClick={scrollToDaohuuthamgia}>Đạo hữu tham gia</button>) }
                { !isAddMode && ( <button  className="tailieu-button" onClick={scrollToTaiLieu}>Tài liệu</button>) }
                { !isAddMode && ( <button  className="sukiendaohuu-button" onClick={scrollToSukienDaohuu}>Chi tiết Đạo hữu</button>) }
                { !isAddMode && ( <button  className="sukiennhadan-button" onClick={scrollToSukienNhadan}>Chi tiết Nhà đàn</button>) }
                <div className="form-row p-2">
                    <Button className="btn btn-secondary  mr-1"  onClick={() => backBrowse()}>
                        <i className="fa fa-arrow-circle-left"> {t('action.label.back')}</i>
                    </Button>
                  {htmlButtonSave}

                </div>
                <div className="form-row p-2">

                </div>

                <div className="tab-pane fade show active" label="Thông tin bán hàng" id="thongtinnhanvien">
                    <div className="card-body">
                        <HRTag title="Thông tin cập nhật" />


                        <div className="row">
                            {/* Họ tên */}
                            <div className="col-md-3">
                                <label className="required">Ngày</label>
                                <NewDatePicker className="form-control w-100" isV2 id="ngay" name="ngay" value={obj.ngay}
                                               onDayChange={onChangeInput} />
                            </div>
                            <div className="col-md-3">
                                <CoquanListComponent coquan_fk = {obj.coquan_fk} onChange ={(opt, e) => {
                                    const target = {name: "coquan_fk", value: opt?.value};
                                    onChangeInput({target});

                                }} />


                            </div>

                            <div className="col-md-3">
                                <NhomsukienListComponent coquan_fk = {obj.coquan_fk} nhomsukien_fk = {obj.nhomsukien_fk} onChange ={(opt, e) => {
                                    const target = {name: "nhomsukien_fk", value: opt?.value};
                                    onChangeInput({target});

                                }} />
                            </div>
                            <div className="col-md-3">
                                <PhanloaisukienListComponent
                                    coquan_fk = {obj.coquan_fk}
                                    nhomsukien_fk = {obj.nhomsukien_fk}
                                    phanloaisukien_fk = {obj.phanloaisukien_fk} onChange ={(opt, e) => {
                                    const target = {name: "phanloaisukien_fk", value: opt?.value};
                                    onChangeInput({target});

                                }} />
                            </div>
                            <div className="col-md-3">
                                <label className="required">Chủ đề</label>
                                <input type="text" className="form-control" name="chu_de" id="chu_de" value={obj.chu_de} onChange={onChangeInput} />
                            </div>
                            <div className="col-md-3">
                                <ThoiListComponent thoi_fk = {obj.thoi_fk} onChange ={(opt, e) => {
                                    const target = {name: "thoi_fk", value: opt?.value};
                                    onChangeInput({target});

                                }} />
                            </div>
                            <div className="col-md-3">
                                <NhadanListComponent
                                    //required = "required"
                                    labelName = 'Nơi tổ chức'
                                    nhadan_fk = {obj.nhadan_fk} onChange ={(opt, e) => {
                                    const target = {name: "nhadan_fk", value: opt?.value};
                                    onChangeInput({target});

                                }} />
                            </div>
                            <div className="col-md-3">
                                <TrangthaiListComponent trangthai_fk = {obj.trangthai_fk}
                                                        onChange ={(opt, e) => {
                                                            const target = {name: "trangthai_fk", value: opt?.value};
                                                            onChangeInput({target});

                                                        }}
                                                        filterIds = { [0,1,2] }
                                                        trangthaiName = "sukien"
                                />

                            </div>



                        </div>

                        <div className="row">
                            <div className="col-md-12">
                                <label>Hình ảnh</label>
                                <input type="text" className="form-control" name="link_image" id="link_image" value={obj.link_image} onChange={onChangeInput} />

                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <label>Ghi chú</label>
                                <textarea rows="2" maxLength="500" className="form-control" name="ghi_chu" id="ghi_chu" value={obj.ghi_chu} onChange={onChangeInput} />
                            </div>
                        </div>

                        { !isAddMode && (
                            <div ref={taiLieuRef}>
                                <HRTag title="Tài liệu" />
                                <TailieuEdit id={id} allowEdit= { !isDisplay } />
                            </div>
                        )}
                        { !isAddMode && (
                            <div ref={daohuuthamgiaRef}>
                                <HRTag title="Đạo hữu tham gia" />
                                <DaohuuthamgiaEdit id={id} allowEdit= { !isDisplay } />
                            </div>
                        )}
                        { !isAddMode && (
                            <div ref={sukiendaohuuRef}>
                                <HRTag title="Chi tiết đạo hữu" />
                                <DaohuuchitietEdit id={id} allowEdit= { !isDisplay } />
                            </div>
                        )}
                        { !isAddMode && (
                            <div ref={sukiennhadanRef}>
                                <HRTag title="Chi tiết nhà đàn" />
                                <NhadanchitietEdit id={id} allowEdit= { !isDisplay } />
                            </div>
                        )}

                    </div>
                </div>
            </div>
                        {/* /.card-body */}
            <div className="card-footer">
            </div>
        </div>
    );
}

export {SukienEdit};
